import { supabase } from '@/lib/supabase/client';
import type { Tables } from '@/lib/supabase/types';
import { queryOptions } from '@tanstack/react-query';

export type StateRow = Tables<'states'>;

export const statesKeys = {
  all: ['states'] as const,
  project: (projectId: string) => ['states', 'project', projectId] as const,
};

export function listStatesByProjectQuery(projectId: string) {
  return queryOptions({
    queryKey: statesKeys.project(projectId),
    queryFn: async () => {
      const { data, error } = await supabase
        .from('states')
        .select('*')
        .eq('project_id', projectId)
        .order('order', { ascending: true });
      if (error) throw error;
      return (data ?? []) as StateRow[];
    },
    staleTime: 5 * 60_000,
  });
}
